import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InboxJobsService, JobsContactService, JobsDeploymentService } from '../../services';
import { MapService, SupplierScheduleService, SupplierService } from '../../services';
import { InputHelper } from '../../utils/input.helper';
import { MessageService } from 'primeng';
import { SupplierCard } from 'src/app/interfaces/supplier-card';

@Component({
  selector: 'supplier-card',
  styleUrls: ['./supplier-card.component.scss'],
  templateUrl: './supplier-card.component.html',
  encapsulation: ViewEncapsulation.None, // todo: check why
})
export class SupplierCardComponent implements OnInit {
  //@ViewChild('sparklineCanvas') sparklineCanvas: ElementRef;

  @Input() public showAvailability: boolean = false;

  public availableImageUrl = 'assets/images/available.png';
  public notAvailableImageUrl = 'assets/images/unavailable.png';
  public excludedImageUrl = 'assets/images/exclusion-icon.png';
  public exclusiveImageUrl = 'assets/images/supplier-exclusive.png';
  public tagRequirementsImageUrl = 'assets/images/tag-requirement-not-met.png';

  public pickupImageUrl = 'assets/images/pickup-icon.png';
  public dropoffImageUrl = 'assets/images/dropoff-icon.png';

  showTaggingRequirements: boolean;

  // Binding properties
  public onDataChanged: EventEmitter<any>;

  @Input('data')
  public set data(value: any) {
    //console.log("Supplier card data: ", value);

    this._data = value;
    this.onDataChanged.emit(value);
    //if (this._data && this._data.id) {
    //    this.loadSparkline();
    //}
    this.carryoverAllowed = !this.data.restrictCarryover;

    if (this.data != null && this.data.supplierAvailability != null) {
      this.data.isAvailable = this.supplierScheduleService.getDayAvailability(
        this.data.jobScheduledDate,
        0,
        0,
        this.data.supplierAvailabilityExceptions,
      );

      //console.log("Got supplier availability, status: ", this.data.isAvailable);
    }
  }

  public get data() {
    return this._data;
  }

  private _data: any;

  public get hasAdditionalTagStatuses() {
    return this.data.additionalTagStatuses && this.data.additionalTagStatuses.length > 0;
  }

  public getDirectStyle() {
    return 'status-additional-direct';
  }

  public getContactedCSS(index: number, isOutcomeName: boolean) {
    const nextStatus = this.data.additionalTagStatuses[index + 1]?.toLowerCase() || '';

    const isHidden = nextStatus.includes('hidden');

    if (isOutcomeName) {
      return isHidden ? 'additional-status-hidden' : 'additional-status-notHidden';
    } else {
      return isHidden ? 'status-Contacted-isHidden' : 'status-Contacted-notHidden';
    }
  }

  public onHideActionsChanged: EventEmitter<boolean>;

  @Input('allocateMode') allocateMode = false;

  @Input('hideActions')
  public set hideActions(value: any) {
    this._hideActions = value;
    this.onHideActionsChanged.emit(value);
  }

  public get hideActions() {
    return this._hideActions;
  }

  private _hideActions: boolean;

  @Output() driverPlanClick: EventEmitter<any>;
  @Output() carryoverAllowedClick: EventEmitter<any>;
  carryoverAllowed: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    private jobDeploymentService: JobsDeploymentService,
    public inboxjobsService: InboxJobsService,
    public mapService: MapService,
    private contactService: JobsContactService,
    private supplierService: SupplierService,
    private supplierScheduleService: SupplierScheduleService,
  ) {
    this.onDataChanged = new EventEmitter<any>();
    this.onHideActionsChanged = new EventEmitter<boolean>();
    this.driverPlanClick = new EventEmitter<any>();
    this.carryoverAllowedClick = new EventEmitter<any>();
  }

  ngOnInit() {}

  public onDriverPlanClick(data) {
    this.driverPlanClick.emit(data);
  }

  public getOntimePercentage(value) {
    if (value == 0 || value == null) return '0.00';

    return value.toFixed(2);
  }

  public mileString(distance) {
    if (Math.round(distance) == 1) return 'mile';
    else return 'miles';
  }

  onTaggingRequirementsClicked() {
    // show the tagging requirements control in a dialog
    // the input to the control is already set in the html template
    this.showTaggingRequirements = true;
  }

  getToolTipInfo(): string {
    if (!this.data.tagRequirementsMet) {
      return 'This supplier does not meet all the tagging requirements for one or more of the orders in this job';
    }
    if (this.data.isExcluded) {
      return 'This supplier is not allowed to work for a customer/dept/team in one or more of the orders in this job';
    }
    if (this.data.isExclusive) {
      return 'This supplier has a preferred customer or customers, and the creator of one or more of the orders in this job are not within that preference range';
    }

    return undefined;
  }

  get jobIsNotCompatible(): boolean {
    return !this.data.tagRequirementsMet || this.data.isExcluded || this.data.isExclusive;
  }

  carryoverAllowedChanged(value) {
    this.carryoverAllowedClick.emit(value);
  }
}
